'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService) {
    let model = this;
    $scope.global = Global;
    model.settings = settings;

    model.lineChartIdentifiers = { key: false, id: false };
    model.rowChartIdentifiers = { key: false, id: false };
    model.geoChartIdentifiers = { key: false, id: false };
    model.sevLevIdentifiers = { key: false, id: false };
    model.tableIdentifiers = { key: false, id: false };

    socketIo('/api/ioc_notifications/inbound_ioc').then(function (socket) {
        /////////////////
        /// LINECHART ///
        /////////////////
        // register data object
        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'linechart',
                socket: socket
            },
            grouping: ['hour','orig_country', 'ioc_severity', 'ioc_class'],
            type: 'linechart',
            settings: {
                type: 'severity',
                xAxis: '',
                yAxis: '# IOC / Hour'
            },
            searchCategories: {
                'time': 'Time',
                'ioc_severity': 'IOC Severity',
                'ioc_class': 'IOC',
                'orig_country': 'Origin Country',
            },
            dimension: function (cfObj) { return cfObj.dimension(function (d) { if (d.time - d.hour < 3600) { d.hour = d.hour*1000; return d.hour; }})},
            group: function (dimension) { // groups are optional and should default to a reduce if undefined
                return dimension.group().reduce(
                    function (p, v) {
                        if (v.ioc_severity === 1) {
                            p.guarded += v.ioc_count;
                        }
                        if (v.ioc_severity === 2) {
                            p.elevated += v.ioc_count;
                        }
                        if (v.ioc_severity === 3) {
                            p.high += v.ioc_count;
                        }
                        if (v.ioc_severity === 4) {
                            p.severe += v.ioc_count;
                        }
                        return p;
                    },
                    function (p, v) {
                        if (v.ioc_severity === 1) {
                            p.guarded -= v.ioc_count;
                        }
                        if (v.ioc_severity === 2) {
                            p.elevated -= v.ioc_count;
                        }
                        if (v.ioc_severity === 3) {
                            p.high -= v.ioc_count;
                        }
                        if (v.ioc_severity === 4) {
                            p.severe -= v.ioc_count;
                        }
                        return p;
                    },
                    function () {
                        return {
                            severe:0,
                            high:0,
                            elevated:0,
                            guarded:0
                        };
                    }
                );
            },
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.lineChartIdentifiers = {
                id: result.id,
                key: result.key
            }
            // set dimension & group
            $scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {
            // stop spinner on complete
            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                usSpinnerService.stop('spinner-'+model.lineChartIdentifiers.id)
            }
        }, function (err) {

        }, function (result) {
            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                $scope.$broadcast('init', model.lineChartIdentifiers);
                // stop spinner on inital data
                usSpinnerService.stop('spinner-'+model.lineChartIdentifiers.id)
            } else {
                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
            }
        })

        ////////////////
        /// ROWCHART ///
        ////////////////
        // register data object
        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            run: function (data) { // optional run function to run after data has been fetched (takes an array of data)
                for (var i = 0, len = data.length; i < len; i++) {
                    data[i].dd = timeFormat(data[i].time, 'strdDateObj');
                    data[i].hour = d3.time.hour(data[i].dd);
                    data[i].count = +data[i].count;
                }
            },
            get: {
                call: 'rowchart',
                socket: socket
            },
            grouping: ['ioc_severity', 'ioc_class'],
            searchCategories: {
                'ioc_class': 'IOC',
                'ioc_severity': 'IOC Severity',
                'orig_country': 'Origin Country',
            },
            type: 'rowchart', // required
            settings: {
                type: 'ioc_family',
            },
            dimension: function (cfObj) {
                return cfObj.dimension(function (d) {
                    return d.ioc_class + d.ioc_severity;
                })
            }, // required
            group: function (dimension) { // groups are optional and should default to a reduce if undefined
                return dimension.group().reduceSum(function (d) {
                    return d.count;
                }).reduce(
                    function (d, v) {
                        if (v.ioc_severity > 0) {
                            d.severity = v.ioc_severity;
                            d.count += v.ioc_count;
                        }
                        return d;
                    },
                    // callback for when data is removed from the current filter results
                    function (d, v) {
                        if (v.ioc_severity > 0) {
                            d.severity = v.ioc_severity;
                            d.count -= v.ioc_count;
                        }
                        return d;
                    },
                    /* initialize d */
                    function (d, v) {
                        return {
                            count: 0,
                            severity: 0
                        };
                    }
                )
            },
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.rowChartIdentifiers = {
                id: result.id,
                key: result.key
            }
            // set dimension & group
            $scope.main.dataObjects[model.rowChartIdentifiers.key].dimension = $scope.main.dataObjects[model.rowChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.rowChartIdentifiers.key].cf);
            $scope.main.dataObjects[model.rowChartIdentifiers.key].group = $scope.main.dataObjects[model.rowChartIdentifiers.key].settings.group($scope.main.dataObjects[model.rowChartIdentifiers.key].dimension);
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {
            // stop spinner on complete
            if (!$scope.main.dataObjects[model.rowChartIdentifiers.key].launched) {
                usSpinnerService.stop('spinner-'+model.rowChartIdentifiers.id);
            }
        }, function (err) {

        }, function (result) {
            $scope.main.dataObjects[model.rowChartIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.rowChartIdentifiers.key].launched) {
                $scope.$broadcast('init', model.rowChartIdentifiers);
                // stop spinner on inital data
                usSpinnerService.stop('spinner-'+model.rowChartIdentifiers.id)
            } else {
                $scope.$broadcast('updatedData', model.rowChartIdentifiers.id, true);
            }
        })

        ////////////////
        /// GEOCHART ///
        ////////////////
        // register data object
        $scope.main.registerVisual({
            refresh: true, // if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'geomap',
                socket: socket
            },
            grouping: ['orig_country', 'ioc_severity', 'ioc_class'],
            searchCategories: {
                'orig_country': 'Origin Country',
                'ioc_severity': 'IOC Severity',
                'ioc_class': 'IOC',
            },
            dimension: function (cfObj) { return cfObj.dimension(function (d) { return d.orig_country; })},
            group: function (dimension) { // groups are optional and should default to a reduce if undefined
                return dimension.group().reduceSum(function (d) {  return d.count }); //Might have to Math.ceil or round
            },
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.geoChartIdentifiers = {
                id: result.id,
                key: result.key
            }
            // set dimension & group
            $scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {
            // stop spinner on complete or no data
            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
                usSpinnerService.stop('spinner-'+model.geoChartIdentifiers.id);
            }
        }, function (err) {

        }, function (result) {
            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
                $scope.$broadcast('init', model.geoChartIdentifiers);
                // stop spinner on inital data
                usSpinnerService.stop('spinner-'+model.geoChartIdentifiers.id);
            } else {
                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
            }
        })


        ///////////////////////
        /// SEVERITY LEVELS ///
        ///////////////////////
        // register data object
        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'sevlevels',
                socket: socket
            },
            grouping: ['ioc_severity','ioc_class', 'orig_country'],
            searchCategories: {
                'ioc_severity': 'IOC Severity',
                'ioc_class': 'IOC',
                'orig_country': 'Origin Country',
            },
            type: 'severityLevels', // required
            dimension: function (cfObj) { return cfObj.dimension(function (d) {  return d.ioc_class + d.ioc_severity; })}, // required
            group: function (dimension) {
                return dimension.group().reduceSum(function (d) {
                    return d.count;
                }).reduce(
                    function (d, v) {
                        d.severity = v.ioc_severity;
                        d.count += v.ioc_count;
                        return d;
                    },
                    // callback for when data is removed from the current filter results
                    function (d, v) {
                        d.severity = v.ioc_severity;
                        d.count -= v.ioc_count;
                        return d;
                    },
                    /* initialize d */
                    function (d, v) {
                        return {
                            count: 0,
                            severity: 0
                        };
                    }
                )
            },
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.sevLevIdentifiers = {
                id: result.id,
                key: result.key
            }
            // set dimension & group
            $scope.main.dataObjects[model.sevLevIdentifiers.key].dimension = $scope.main.dataObjects[model.sevLevIdentifiers.key].settings.dimension($scope.main.dataObjects[model.sevLevIdentifiers.key].cf);
            $scope.main.dataObjects[model.sevLevIdentifiers.key].group = $scope.main.dataObjects[model.sevLevIdentifiers.key].settings.group($scope.main.dataObjects[model.sevLevIdentifiers.key].dimension);
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {

        }, function (err) {

        }, function (result) {
            $scope.main.dataObjects[model.sevLevIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.sevLevIdentifiers.key].launched) {
                $scope.$broadcast('init', model.sevLevIdentifiers);
            } else {
                $scope.$broadcast('updatedData', model.sevLevIdentifiers.id, true);
            }
        })

        /////////////
        /// TABLE ///
        /////////////
        // register data object
        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'table',
                socket: socket
            },
            grouping: ['resp_ip','resp_hostname','orig_ip','ioc_class'],
            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
            title: 'Inbound Indicators of Compromise (IOC) Notifications',
            columns: [
                {
                    title: 'Last Seen',
                    select: 'time',
                    dView: true,
                    link: {
                        type: 'ioc_events_drilldown',
                        val: ['resp_ip','orig_ip','resp_hostname','ioc_class','ioc_child', 'vector'],
                        crumb: false
                    },
                },
                { title: 'Responder Stealth', select: 'resp_stealth', dView: true },
                { title: 'Blocked by Proxy', select: 'proxy_blocked', dView: true },
                { title: 'Severity', select: 'ioc_severity', dView: true },
                { title: 'IOC Count', select: 'ioc_count', dView: true },
                { title: 'IOC', select: 'ioc_class', dView: true },
                { title: 'IOC Type', select: 'ioc_type', dView: true },
                // { title: 'IOC Stage', select: 'ioc_stage', dView: true },
                { title: 'IOC Rule', select: 'ioc_rule', dView: true },
                { title: 'Responder Hostname', select: 'resp_hostname', dView: true },
                { title: 'Responder User', select: 'resp_user', dView: true },
                { title: 'Responder IP', select: 'resp_ip', dView: true },
                { title: 'Origin IP', select: 'orig_ip', dView: true },
                { title: 'Origin Country', select: 'orig_country', dView: true },
                { title: 'Flag', select: 'orig_cc', dView: true },
                { title: 'Origin ASN', select: 'orig_asn_name', dView: true },
                { title: 'Payload Ratio', select: 'breakdown', dView: true },
                { title: 'Origin Payload', select: 'bytes_orig', dView: true },
                { title: 'Responder Payload', select: 'bytes_resp', dView: true },
                // {
                //     title: '',
                //     select: 'Archive',
                //     dView: true,
                //     link: {
                //         type: 'Archive',
                //     },
                // }
            ],
            searchCategories: {
                'resp_stealth': 'Responder Stealth',
                'proxy_blocked': 'Blocked by Proxy',
                'ioc_severity': 'Severity',
                'ioc_count': 'IOC Count',
                'ioc_class': 'IOC',
                'ioc_type': 'IOC Type',
                // 'ioc_stage': 'IOC Stage',
                'ioc_rule': 'IOC Rule',
                'resp_hostname': 'Responder Hostname',
                'resp_user': 'Responder User',
                'resp_ip': 'Responder IP',
                'orig_ip': 'Origin IP',
                'orig_country': 'Origin Country',
                'orig_cc': 'Flag',
                'orig_asn_name': 'Origin ASN',
            }
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.tableIdentifiers = {
                id: result.id,
                key: result.key
            }
            // initalize table with column information so it can compile the directive
            $scope.$broadcast('table-build', model.tableIdentifiers);
            let time = angular.copy($scope.main.getTime());
            model.loadStart = time.end
            model.loadEnd = time.end
            // return promise to build dimensions and groups for table
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {
            model.complete = true;
            // stop the table spinner as soon as the resolve comes in
            usSpinnerService.stop(model.tableIdentifiers.id);
        }, function (err) {

        }, function (result) {
            // add rows
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                // with our first data return, we can build dimensions and groups for our data
                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
                    // dont start the spinner if the table loads faster than building group dim
                    if (!model.complete) {
                        // start table spinner right before init, but after build
                        usSpinnerService.spin(model.tableIdentifiers.id);
                    }
                    // initalize rows
                    $scope.$broadcast('init', model.tableIdentifiers);
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                }, function (err) {
                    console.log('error')
                    console.log(err)
                })
            } else {
                if (result.min) {
                    model.loadStart = result.min;
                }
                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
            }
        })
        $scope.$on('$destroy', function () {
            socket.disconnect();
        });
    })

};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/ioc_notifications/inbound_ioc.js
 **/